import {
    type GetAllFormsForAdminResponseType
} from "./type";
import {
    request
} from "../request";

const getAllFormsForAdmin = async (): Promise<GetAllFormsForAdminResponseType> => {
    return await request<GetAllFormsForAdminResponseType>("/events/getAllFormsForAdmin", {
        method: "GET"
    });
};

export default getAllFormsForAdmin;
